import { BeneficiaryInsightDimension } from '@repo/shared/dtos/beneficiary'
import { StructuredDataSchemaItem } from '@repo/shared/dtos/structured-data'
import { Button } from '@repo/ui/button'
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@repo/ui/command'
import { useT } from '@repo/ui/hooks'
import { Popover, PopoverContent, PopoverTrigger } from '@repo/ui/popover'
import { Plus } from 'lucide-react'
import { useState } from 'react'

import { buildDimension } from './helpers'

export function AddDimensionButton({
  schemaItems,
  onAdd,
}: {
  schemaItems: StructuredDataSchemaItem[]
  onAdd: (dimension: BeneficiaryInsightDimension) => void
}) {
  const { t } = useT({ keyPrefix: 'admin.insights.form.dimensions.addButton' })
  const [open, setOpen] = useState(false)

  const onClick = (schemaItem: StructuredDataSchemaItem) => {
    onAdd(buildDimension(schemaItem))
    setOpen(false)
  }

  return (
    <div className="flex justify-center mt-4">
      <Popover modal open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" className="data-[state=open]:bg-opacity-90">
            <Plus className="size-4" />
            <span>{t('label')}</span>
          </Button>
        </PopoverTrigger>
        <PopoverContent align="start" className="overflow-y-hidden p-0">
          <Command>
            <CommandInput placeholder={t('searchPlaceholder', { cfl: true })} className="h-9" />
            <CommandList>
              <CommandEmpty>{t('none', { cfl: true })}</CommandEmpty>
              <CommandGroup>
                {schemaItems.map((schemaItem) => (
                  <CommandItem key={schemaItem.id}>
                    <div className="w-full h-full" onClick={() => onClick(schemaItem)}>
                      {schemaItem.label}
                    </div>
                  </CommandItem>
                ))}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
    </div>
  )
}
